import { UserAuthentified } from '@app/authentification/user-authentified.interface';

export enum ProductsTypeEnum {
  SCPI = 'SCPI',
  PER = 'PER',
  CONTRAT_CAPI = 'CONTRAT_CAPI',
  PEI = 'PEI',
  PERCO = 'PERCO',
  PREFON = 'PREFON',
  PEE = 'PEE',
  PERP = 'PERP',
  ASSURANCE_VIE = 'ASSURANCE_VIE',
  FCPI = 'FCPI',
  FIP = 'FIP',
  FIP_CORSE = 'FIP_CORSE',
  FIP_DOMTOM = 'FIP_DOMTOM',
  GIRARDIN = 'GIRARDIN',
  INVESTISSEMENT_PME = 'INVESTISSEMENT_PME',
  SOFICA = 'SOFICA',
  LMNP = 'LMNP',
  TANGIBLES = 'TANGIBLES',
  CROWDFUNDING = 'CROWDFUNDING',
  DEFISCALISATION = 'DEFISCALISATION',
  PRIVATE_EQUITY = 'PRIVATE_EQUITY',
  BORROWER_INSURANCE = 'BORROWER_INSURANCE',
  //UNFURNISHED
  UNFURNISHED = 'UNFURNISHED',
  CAT = 'CAT',
  PRESTATION = 'PRESTATION',
  FCPR = 'FCPR',
  FPS = 'FPS',
  FPCI = 'FPCI',
  FPCR = 'FPCR',
  BOND = 'BOND',
  GFV = 'GFV',
  GFI = 'GFI',
  GFF = 'GFF',
  TITRES_PARTICIPATIFS = 'TITRES_PARTICIPATIFS',
  SOCIAL_SHARE = 'SOCIAL_SHARE',
  OBLIGATIONS = 'OBLIGATIONS',
  DIVERSIFICATION_INVESTMENT = 'DIVERSIFICATION_INVESTMENT',
  COMPTE_TITRE = 'COMPTE_TITRE',
  PEA = 'PEA',
  CONTINGENCY = 'CONTINGENCY',
  INSURANCE = 'INSURANCE',
  PME = 'PME',
}
export interface ProductInfo {
  id: number;
  name: ProductsTypeEnum;
  label?: string;
}

export interface FormFields {
  name: string;

  type?: 'string' | 'number' | 'boolean' | 'date' | 'array' | 'object';
  formFields?: FormFields[];
  required?: boolean;
  requiredBasedOn?: string;
}
export enum categoryEnum {
  'État civil',
  'Entité morale',
  'Profil patrimonial',

  'Connaissances financières',
  'Composition du crédit',
  'Composition du contrat',
  'LCB-FT',

  'Questions supplémentaire',
  'Signature',
}

export interface Question {
  id?: number | string;
  name: string;

  step?: any;
  isComplete?: boolean;
  formFields?: FormFields[];
  template: string;
  alwaysShow?: (entity: any, user?: UserAuthentified) => boolean;
  alwaysSkip?: boolean;

  isConsultant?: boolean;
  callbackValidation?: (entity: any, user?: UserAuthentified) => boolean;
  callbackBasedOn?: (entity: any, user?: UserAuthentified) => boolean;
  callbackClient?: (entity: any) => boolean;
  callbackConsultant?: (entity: any) => boolean;
  getTitle?: (entity: any, user?: UserAuthentified) => string;
  getSubTitle?: (entity: any, user?: UserAuthentified) => string;
  title?: string;
  subTitle?: string;
  type?: 'owners' | 'products' | 'parameters';
  productType: Array<keyof typeof ProductsTypeEnum>;
  showFirstTime?: boolean;
  physicalUserOnly?: boolean;
  companyOnly?: boolean;
  category?: keyof typeof categoryEnum;

  categoryId?: number;
}
export interface ProductQuestionDetail {
  id: number;
  name: ProductsTypeEnum;
  questionIds: (string | number)[];
}
